<template>
	<div>
		<div class="subtitle-2">Cover Image</div>
    <div 
     v-if="!item.cover_image" 
     class="black--text text-center pa-5 mt-md-1 image-style"
     @click="dialog=true"
     >
      set cover image
    </div>
    <div v-else>
    	<v-img
    	width="285"
    	height="100"
  	  @click="dialog=true"
  	  class="image-style"
    	:src="item.cover_image.feature_image"
    	>
    	</v-img>
    </div>
	  <image-picker-modal 
	   :dialog="dialog"
	   :coverImageId="item.cover_image_id"
	   @closeDialog="dialog=false"
	   @updateItem="update"
	   />
	</div>
</template>
<script>
import ImagePickerModal from '@/components/modals/ImagePickerModal'
export default {
	props:{
		item: { // category or location
			type: Object
		},
		libraryImages: {
			type: Array
		}
	},

	components: {
		ImagePickerModal
	},

	data() {
		return {
			dialog: false,
		}
	},

	methods: {
	 update(image) {
	 	this.$emit('updateItem', image);
   } 		
	}

}
</script>
<style lang="scss">
.image-style {
	background-color: #eee;
	cursor: pointer;
}
</style>